// extracted by mini-css-extract-plugin
module.exports = {"layerStyleDialog":"CustomLayerStylesDialog_layerStyleDialog__Dsy_O","label":"CustomLayerStylesDialog_label__g7zKj","select":"CustomLayerStylesDialog_select__19n0a"};